/**
 * @flow
 * @relayHash d548336b951b19a00570a6220d3fe8f3
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateDataSetDownloadInput = {
  indicators?: ?$ReadOnlyArray<?string>,
  geographicProfiles?: ?$ReadOnlyArray<?GeographicProfileInput>,
  startYear?: ?number,
  endYear?: ?number,
  boardSections?: ?$ReadOnlyArray<?string>,
  addToPublicFeed?: ?boolean,
  benchmarks?: ?boolean,
  clientMutationId?: ?string,
};
export type GeographicProfileInput = {
  geographicUnit?: ?string,
  geographicFilters?: ?$ReadOnlyArray<?GeographicFilterInput>,
};
export type GeographicFilterInput = {
  geographicUnit?: ?string,
  geoId?: ?string,
  savedAreaId?: ?string,
};
export type ShareMapPopupDownloadMapDataMutationVariables = {|
  input: CreateDataSetDownloadInput
|};
export type ShareMapPopupDownloadMapDataMutationResponse = {|
  +createDataSetDownload: ?{|
    +dataSetDownloadNode: ?{|
      +id: string
    |}
  |}
|};
export type ShareMapPopupDownloadMapDataMutation = {|
  variables: ShareMapPopupDownloadMapDataMutationVariables,
  response: ShareMapPopupDownloadMapDataMutationResponse,
|};
*/


/*
mutation ShareMapPopupDownloadMapDataMutation(
  $input: CreateDataSetDownloadInput!
) {
  createDataSetDownload(input: $input) {
    dataSetDownloadNode {
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateDataSetDownloadInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "createDataSetDownload",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "CreateDataSetDownloadInput!"
      }
    ],
    "concreteType": "CreateDataSetDownloadPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "dataSetDownloadNode",
        "storageKey": null,
        "args": null,
        "concreteType": "DataSetDownloadNode",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "ShareMapPopupDownloadMapDataMutation",
  "id": null,
  "text": "mutation ShareMapPopupDownloadMapDataMutation(\n  $input: CreateDataSetDownloadInput!\n) {\n  createDataSetDownload(input: $input) {\n    dataSetDownloadNode {\n      id\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ShareMapPopupDownloadMapDataMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "ShareMapPopupDownloadMapDataMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '9d00291c9e5ab1cc1057b37959ad9e7d';
module.exports = node;



// WEBPACK FOOTER //
// ./src/components/CommonComponents/__generated__/ShareMapPopupDownloadMapDataMutation.graphql.js